export default __webpack_public_path__ + "static/media/Camera.af353fb8.svg";